import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'
import VueTour from 'vue-tour'
import '../css/vue-tour.css'// resources/plugins/vuetify.js
import '@fortawesome/fontawesome-free/css/all.css'


Vue.use(VueTour)
Vue.use(Vuetify)
export default new Vuetify({
  icons: { iconfont: 'fa' },
})